import { render } from "./MemoruSales.vue?vue&type=template&id=566afd64&scoped=true&ts=true"
import script from "./MemoruSales.vue?vue&type=script&lang=ts"
export * from "./MemoruSales.vue?vue&type=script&lang=ts"

import "./MemoruSales.vue?vue&type=style&index=0&id=566afd64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566afd64"]])

export default __exports__